import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { useGetLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Tab from "@insite/mobius/Tab";
import TabGroup, { TabGroupPresentationProps } from "@insite/mobius/TabGroup";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MinusIcon from "@tSurya/Icons/MinusIcon";
import PlusIcon from "@tSurya/Icons/PlusIcon";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    tabTitle = "tabTitle",
    desc = "desc",
    numberOfTabs = "numberOfTabs",
    faqBoxes = "faqBoxes",
    cssClass = "cssClass",
    image = "image",
    newImage = "newImage",
    imgLink = "imgLink",
    imgTitle = "imgTitle",
    tittleLink = "tittleLink",
}

interface NameArray {
    name: string;
    faqBoxes: FAQModel[];
}

interface TabModel {
    fields: NameArray;
}

interface FAQArray {
    questions: string;
    answers: string;
    newImage: string;
    imgLink: string;
    tittleLink: LinkFieldValue;
    imgTitle: string;
}

interface FAQModel {
    fields: FAQArray;
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.tabTitle]: string;
        [fields.desc]: string;
        [fields.numberOfTabs]: TabModel[];
        [fields.faqBoxes]: FAQModel;
        [fields.cssClass]: string;
        [fields.tittleLink]: LinkFieldValue;
    };
}

type Props = OwnProps;
export interface SurTabularDataStyles {
    tabView?: InjectableCss;
    tabTitle?: InjectableCss;
    container?: InjectableCss;
    desc?: InjectableCss;
    imageStyles?: InjectableCss;
    tabGroup?: TabGroupPresentationProps;
    accordianContainer?: InjectableCss;
    accordianSection?: AccordionSectionPresentationProps;
    imageContainer?: InjectableCss;
    imgLink?: InjectableCss;
    imgTitle?: InjectableCss;
}
export const tabularDataStyles: SurTabularDataStyles = {
    tabView: {
        css: css`
            background: ${getColor("common.background")};
            padding: 8px 12px;
            font-style: normal;
            min-width: auto;
            background-color: #f4f3f1;
            outline: 0;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 400;
            font-size: 15px;
            line-height: 24px;
            color: red;
            cursor: pointer;
            :focus {
                outline: 0;
            }

            /* border: 1px solid red; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 12px;
                    `,
                    css`
                        padding: 12px;
                    `,
                    css`
                        padding: 12px;
                    `,
                    null,
                    null,
                ])}
            &[aria-selected="true"] {
                border-bottom: 2px solid ${getColor("common.border")};
                span {
                    font-family: "Mulish";
                    font-style: normal;
                    font-weight: 700;
                    font-size: 15px;
                    line-height: 24px;
                    color: #866a5b;
                }
            }
        `,
    },
    tabTitle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.xlargest};
            line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
            color: ${getColor("text.main")};
            /* identical to box height, or 117% */
            margin-bottom: 24px;
            text-align: center;
            text-transform: uppercase;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.size.xlargest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                    `,
                    css`
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.size.xlargest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                    `,
                    css`
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.size.xlargest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                    `,
                    null,
                    null,
                ])}
        `,
    },
    desc: {
        css: css`
            text-align: center;
            width: 100%;
            margin-bottom: 36px;
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            font-weight: ${TYPOGRAPHY.weight.base};
            color: ${getColor("text.main")};
        `,
    },
    imageStyles: {
        css: css`
            /* max-width: 380px; */
            max-height: 454px;
            img {
                height: 100%;
                width: 100%;
                max-width: 380px;
                object-fit: cover;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            max-width: 339px;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },
    container: {
        css: css`
            > div[class^="TabGroupWrapper"] {
                padding: 0px !important;
            }
        `,
    },
    tabGroup: {
        cssOverrides: {
            tabGroup: css`
                align-items: center;
                justify-content: start;
                gap: 21px;
                padding: 0px;
                z-index: 9;
                /* margin-bottom: 35px;
                margin-top: 60px; */
                margin: 0px auto 32px;
                > li > span {
                    font-family: "Mulish";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 24px;
                    color: ${getColor("text.main")};
                }
            `,
            tabContent: css`
                border: none;
                max-width: 1280px;
                margin: 0 auto;
                padding: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 20px;
                        `,
                        css`
                            padding: 20px;
                        `,
                        css`
                            padding: 20px;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    accordianContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-bottom: 54px;
        `,
    },
    accordianSection: {
        headerProps: {
            css: css`
                & button,
                & button:focus {
                    background-color: ${getColor("common.backgroundContrast")};

                    padding: 24px 20px;
                    border: 0;
                    > span:first-of-type {
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-weight: ${TYPOGRAPHY.weight.bold};
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.size.smaller};
                        line-height: ${TYPOGRAPHY.lineHeight.base};
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                padding: 9px 20px 25px 40px;
                border: 0;
                &:not(dd[hidden]) {
                    display: flex;
                    display: flex;
                    align-items: center;
                }
                > span {
                    padding-left: 40px;
                    > p {
                        display: list-item;
                        margin-bottom: 0;
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-weight: ${TYPOGRAPHY.weight.base};
                        color: ${getColor("text.accent")};
                        font-size: ${TYPOGRAPHY.size.smaller};
                        line-height: ${TYPOGRAPHY.lineHeight.base};
                    }
                }
            `,
        },
        expandIconProps: {
            src: PlusIcon,
        },
        collapseIconProps: {
            src: MinusIcon,
        },
    },
    imageContainer: {
        css: css`
            /* max-width: 1280px; */
            /* margin: 0 auto; */
            /* border: 1px solid red; */
            display: flex;
            /* grid-template-columns: 1fr 1fr 1fr; */
            flex-wrap: wrap;
            column-gap: 70px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        column-gap: 50px;
                        justify-content: flex-start;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    imgLink: {
        css: css`
            span {
                font-family: "Mulish";
                font-style: normal;
                font-weight: 700;
                font-size: 18px;
                line-height: 26px;
                color: ${getColor("text.main")} !important;
                margin-top: 12px;
            }
        `,
    },
};

const styles = tabularDataStyles;

const SurTabAccordian: React.FC<Props> = ({ fields, id }) => {
    // const dataLink: any = fields.numberOfTabs.map(data => {
    //     return data.fields.faqBoxes.map(item => {
    //         return item.fields.tittleLink;
    //     });
    // });

    const getURL = (item: LinkFieldValue) => {
        const { url } = useGetLink(item);
        return url;
    };

    const [expandedAccordian, setExpandedAccordian] = React.useState<number | null>(null);
    // const allFaqs = [
    //     {
    //         fields: {
    //             name: "All",
    //             faqBoxes: fields.numberOfTabs.map(item => item.fields.faqBoxes).reduce((acc, el) => acc.concat(el), []),
    //         },
    //     },
    // ];

    const AllContent = [...fields.numberOfTabs];
    return (
        <StyledWrapper {...styles.container}>
            <TabGroup current={AllContent[0]?.fields.name} {...styles.tabGroup}>
                {AllContent.map(numberOfTab => {
                    return (
                        // eslint-disable-next-line react/jsx-key
                        <Tab
                            headline={numberOfTab.fields.name}
                            tabKey={numberOfTab.fields.name}
                            {...styles.tabView}
                            onClickCapture={() => setExpandedAccordian(null)}
                        >
                            <StyledWrapper {...styles.imageContainer}>
                                {numberOfTab.fields.faqBoxes.map((faqs: FAQModel, index: number) => {
                                    return (
                                        // eslint-disable-next-line react/no-array-index-key, react/jsx-key
                                        <StyledWrapper {...tabularDataStyles.accordianContainer} key={index}>
                                            <LazyImage src={faqs.fields.newImage} {...styles.imageStyles} />
                                            {/* <Link {...styles.imgLink} href={getURL(faqs.fields.tittleLink)}>
                                                {faqs.fields.imgLink}
                                            </Link> */}
                                            <Typography as="h5">{faqs.fields.imgTitle}</Typography>
                                        </StyledWrapper>
                                    );
                                })}
                            </StyledWrapper>
                        </Tab>
                    );
                })}
            </TabGroup>
        </StyledWrapper>
    );
};

const SurTabImageAccordianWidget: WidgetModule = {
    component: SurTabAccordian,
    definition: {
        group: "Common",
        displayName: "Sur Press Widget",
        fieldDefinitions: [
            {
                name: fields.numberOfTabs,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.name;
                },
                defaultValue: [],
                fieldType: "General",
                sortOrder: 1,
                fieldDefinitions: [
                    {
                        name: "name",
                        displayName: "Tab Name",
                        editorTemplate: "TextField",
                        sortOrder: 0,
                        defaultValue: "",
                    },

                    {
                        name: fields.faqBoxes,
                        displayName: "Catalog Data",
                        editorTemplate: "ListField",
                        getDisplay: (item: HasFields) => {
                            return item.fields.questions;
                        },
                        defaultValue: [],
                        sortOrder: 1,
                        fieldDefinitions: [
                            {
                                displayName: "Image",
                                name: "newImage",
                                editorTemplate: "ImagePickerField",
                                defaultValue: "",
                            },
                            {
                                name: "imgLink",
                                displayName: "Image Link",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "imgTitle",
                                displayName: "Image Title",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "tittleLink",
                                displayName: "Redirect Link",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: "Page",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                name: fields.cssClass,
                displayName: "Add CSS Class",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};
export default SurTabImageAccordianWidget;
